const AnswerOption = ({ option, onClick, selected = false, correct = null, disabled = false, index }) => {
	// Colors for options based on state
	const getColorClasses = () => {
		// If we're showing results (correct is not null)
		if (correct !== null) {
			if (option === correct) return 'bg-success-100 border-success-500 text-success-800';
			if (selected && option !== correct) return 'bg-danger-100 border-danger-500 text-danger-800';
			return 'bg-gray-100 border-gray-300 text-gray-800 opacity-70';
		}

		// During selection
		if (selected) return 'bg-primary-100 border-primary-500 text-primary-800';
		return 'bg-white border-gray-300 hover:bg-gray-50';
	};

	// Colors for option indices
	const optionColors = ['bg-red-500', 'bg-blue-500', 'bg-yellow-500', 'bg-green-500'];

	return (
		<button
			className={`option-btn ${getColorClasses()} flex items-center`}
			onClick={() => !disabled && onClick(option)}
			disabled={disabled}
		>
			<div
				className={`${
					optionColors[index % 4]
				} w-8 h-8 rounded-full flex items-center justify-center text-white font-bold mr-3`}
			>
				{String.fromCharCode(65 + index)}
			</div>
			<span>{option}</span>
		</button>
	);
};

export default AnswerOption;
